import React from 'react';

import Header from '../../layout/Header.jsx';
import ListStudents from '../../lists/ListStudents.jsx';

const PageSchools = () => (
  <div>
    <Header>Students</Header>
    <ListStudents
      deactivateAll={true}
      basePath={(r) => `/admin/schools/${r.school._id}/students/`}
    />
  </div>
);

export default PageSchools;
